import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { THERAPISTS } from '../data/services';

const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzanzU8ZdSqF3JpbAkJQuZwKr1gXiSYkCHsqszNTgsZKXIMGF52REdUXsgXzHzZj1k/exec';


interface AppointmentModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const AppointmentModal: React.FC<AppointmentModalProps> = ({ isOpen, onClose }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    console.log(isSubmitting);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [formData, setFormData] = useState({
        name: '',
        age: '',
        gender: '',
        email: '',
        whatsapp: '',
        daysAvailable: [] as string[],
        timingsAvailable: '',
        therapyModeLocation: '',
        concern: '',
        probonoEligibility: false,
        priceRange: '',
        therapistPreferences: '',
        selectedTherapist: '',
        referralSource: '',
        socialMediaPlatform: '',
        otherReferralSource: '',
        contactConsent: false,
    });

    const daysOfWeek = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
    ];

    const priceRangeOptions = [
        "0-500",
        "500-1000",
        "1000-1500",
        "1500-2000",
        "2000+"
    ];

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value, type } = e.target;

        if (name === 'daysAvailable' && type === 'checkbox') {
            const checked = (e.target as HTMLInputElement).checked;
            const dayValue = value;

            setFormData(prevData => {
                if (checked) {
                    // Add the day if checked
                    return {
                        ...prevData,
                        daysAvailable: [...prevData.daysAvailable, dayValue]
                    };
                } else {
                    // Remove the day if unchecked
                    return {
                        ...prevData,
                        daysAvailable: prevData.daysAvailable.filter(day => day !== dayValue)
                    };
                }
            });
        } else {
            // Handle other form fields normally
            const newValue = type === 'checkbox' ? (e.target as HTMLInputElement).checked : value;
            setFormData(prevData => ({
                ...prevData,
                [name]: newValue
            }));
        }
    };

    const submitToGoogleSheets = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!formData.contactConsent) {
            alert("Please agree to be contacted by our team.");
            return;
        }

        if (formData.daysAvailable.length === 0) {
            alert("Please select at least one day when you're available.");
            return;
        }

        if (formData.priceRange === "Pro-bono (5 free sessions, then 0-500)" && !formData.probonoEligibility) {
            alert("Please confirm your eligibility for pro-bono therapy.");
            return;
        }

        console.log("Form data being sent:", formData);
        console.log("Price Range:", formData.priceRange);
        console.log("Therapy Mode Location:", formData.therapyModeLocation);

        setIsSubmitting(true);
        setIsLoading(true);

        try {

            const ipResponse = await fetch('https://api.ipify.org?format=json');
            const ipData = await ipResponse.json();

            const response = await fetch(GOOGLE_SCRIPT_URL, {
                method: 'POST',
                mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    timeStamp: new Date().toISOString(),
                    ipAddress: ipData.ip,
                    ...formData,
                    daysAvailable: formData.daysAvailable.join(", ")
                })
            });
            console.log("Response : ", response);
            await new Promise(resolve => setTimeout(resolve, 1000));

            setSubmitSuccess(true);
            // sendWhatsAppMessage();

            setFormData({
                name: '',
                age: '',
                gender: '',
                email: '',
                whatsapp: '',
                daysAvailable: [] as string[],
                timingsAvailable: '',
                therapyModeLocation: '',
                concern: '',
                probonoEligibility: false,
                priceRange: '',
                therapistPreferences: '',
                selectedTherapist: '',
                referralSource: '',
                socialMediaPlatform: '',
                otherReferralSource: '',
                contactConsent: false,
            });
        } catch (error) {
            console.error('Error submitting form: ', error);
            alert('There was an error submitting the form. PLEASE TRY AGAIN');
        } finally {
            setIsSubmitting(false);
            setIsLoading(false);
        }
    };

    // const sendWhatsAppMessage = () => {
    //     const message = `New Appointment Request:
    //         Name: ${formData.name}
    //         Age: ${formData.age}
    //         Gender: ${formData.gender}
    //         Whatsapp: ${formData.whatsapp}
    //         Email: ${formData.email}
    //         Days Available: ${formData.daysAvailable.join(", ")}
    //         Timing Available: ${formData.timingsAvailable}
    //         Therapy Mode : ${formData.therapyModeLocation}
    //         Concern: ${formData.concern}
    //         Probono Eligibility:  ${formData.probonoEligibility ? formData.probonoEligibility : 'NA'}
    //         Therapist Preferences: ${formData.therapistPreferences}
    //         Selected Therapist : ${formData.selectedTherapist}
    //         Price Range : ${formData.priceRange}
    //         Referral Source : ${formData.referralSource}, 
    //         Social Media Platform : ${formData.socialMediaPlatform},`;

    //     const whatsappNumber = '918591049845';
    //     const encodedMessage = encodeURIComponent(message);
    //     const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    //     window.open(whatsappUrl, '_blank');
    // };

    const DaysAvailableDropdown = () => {
        const [isOpen, setIsOpen] = useState(false);

        const dropdownRef = useRef<HTMLDivElement>(null);

    // Add click outside handler
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        }
        
        // Add event listener when dropdown is open
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        
        // Clean up
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    // Stop propagation on checkbox clicks
    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation(); // Prevent event bubbling
        handleChange(e);
    };

        return (
            <div className="relative" ref={dropdownRef}>
                <button
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    className="mt-1 w-full flex justify-between items-center border border-teal-300 rounded-md shadow-sm p-2 bg-white text-teal-900 focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                >
                    <span>{formData.daysAvailable.length ? `${formData.daysAvailable.length} days selected` : 'Select days'}</span>
                    <svg className="h-5 w-5 text-teal-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isOpen ? "M5 15l7-7 7 7" : "M19 9l-7 7-7-7"} />
                    </svg>
                </button>

                {isOpen && (
                    <div className="absolute z-10 mt-1 w-full bg-white border border-teal-300 rounded-md shadow-lg">
                        <div className="p-2 space-y-1 max-h-60 overflow-y-auto">
                            {daysOfWeek.map(day => (
                                <div key={day} className="flex items-center p-1 hover:bg-teal-50 rounded">
                                    <input
                                        type="checkbox"
                                        id={`day-${day}`}
                                        name="daysAvailable"
                                        value={day}
                                        checked={formData.daysAvailable.includes(day)}
                                        onChange={handleCheckboxChange}
                                        onClick={(e) => e.stopPropagation()}
                                        className="h-4 w-4 border border-teal-300 rounded focus:ring-2 focus:ring-teal-400"
                                    />
                                    <label htmlFor={`day-${day}`} className="ml-2 text-sm text-teal-700 w-full cursor-pointer">
                                        {day}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    };



    const LoadingOverlay = () => (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-white bg-opacity-75">
            <div className="flex flex-col items-center">
                <div className="animate-spin">
                    <svg
                        className="w-16 h-16 text-teal-400"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        ></circle>
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                    </svg>
                </div>
                <p className="mt-4 text-lg text-teal-700">Submitting Your Request...</p>
            </div>
        </div>
    );



    return ReactDOM.createPortal(
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 bg-teal-200 bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-4 z-[1000]"
                >
                    <motion.div
                        initial={{ y: -50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: -50, opacity: 0 }}
                        className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-lg"
                    >
                        <h2 className="text-2xl font-bold mb-4 text-center font-fraunces-slab text-teal-800">Connect with Your Therapist</h2>

                        {submitSuccess ? (
                            <div className="flex flex-col items-center space-y-4 p-6">
                                <div className="text-center">
                                    <p className="text-2xl font-bold text-teal-800 mb-3">Thank You!</p>
                                    <p className="text-teal-700 font-work-sans">We'll be in touch soon.</p>
                                </div>
                                <button
                                    onClick={onClose}
                                    className="px-6 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-teal-400"
                                >
                                    Close
                                </button>
                            </div>
                        ) : (
                            <form onSubmit={submitToGoogleSheets} className="space-y-4 font-work-sans">
                                <div>
                                    <label htmlFor="name" className="block text-sm font-medium text-teal-700">Name/Initials</label>
                                    <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required
                                        className="mt-1 block w-full border border-teal-300 rounded-md shadow-sm p-2 bg-white text-teal-900 focus:ring-2 focus:ring-teal-400 focus:border-transparent" />
                                </div>

                                <div>
                                    <label htmlFor="age" className="block text-sm font-medium text-teal-700">Age</label>
                                    <input type="number" id="age" name="age" value={formData.age} onChange={handleChange} required
                                        className="mt-1 block w-full border border-teal-300 rounded-md shadow-sm p-2 bg-white text-teal-900 focus:ring-2 focus:ring-teal-400 focus:border-transparent" />
                                </div>

                                <div>
                                    <label htmlFor="gender" className="block text-sm font-medium text-teal-700">Gender you identify with</label>
                                    <input type="text" id="gender" name="gender" value={formData.gender} onChange={handleChange} required
                                        className="mt-1 block w-full border border-teal-300 rounded-md shadow-sm p-2 bg-white text-teal-900 focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                                        placeholder="Please specify your gender identity" />
                                </div>

                                <div>
                                    <label htmlFor="email" className="block text-sm font-medium text-teal-700">Email</label>
                                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required
                                        className="mt-1 block w-full border border-teal-300 rounded-md shadow-sm p-2 bg-white text-teal-900 focus:ring-2 focus:ring-teal-400 focus:border-transparent" />
                                </div>

                                <div>
                                    <label htmlFor="whatsapp" className="block text-sm font-medium text-teal-700">WhatsApp Number</label>
                                    <input type="tel" id="whatsapp" name="whatsapp" value={formData.whatsapp} onChange={handleChange} required
                                        className="mt-1 block w-full border border-teal-300 rounded-md shadow-sm p-2 bg-white text-teal-900 focus:ring-2 focus:ring-teal-400 focus:border-transparent" />
                                </div>

                                <div>
                                    <label htmlFor="daysAvailable" className="block text-sm font-medium text-teal-700">Days Available</label>
                                    <DaysAvailableDropdown />
                                </div>

                                <div>
                                    <label htmlFor="timingsAvailable" className="block text-sm font-medium text-teal-700">Timings Available</label>
                                    <input type="text" id="timingsAvailable" name="timingsAvailable" value={formData.timingsAvailable} onChange={handleChange} required
                                        className="mt-1 block w-full border border-teal-300 rounded-md shadow-sm p-2 bg-white text-teal-900 focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                                        placeholder="Please specify your preferred timings" />
                                </div>

                                <div>
                                    <label htmlFor="therapyModeLocation" className="block text-sm font-medium text-teal-700">
                                        Therapy Mode & Location
                                    </label>
                                    <input
                                        type="text"
                                        id="therapyModeLocation"
                                        name="therapyModeLocation"
                                        value={formData.therapyModeLocation}
                                        onChange={handleChange}
                                        required
                                        className="mt-1 block w-full border border-teal-300 rounded-md shadow-sm p-2 bg-white text-teal-900 focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                                        placeholder="Online or Offline? If offline, please specify city and area"
                                    />
                                </div>

                                <div>
                                    <label htmlFor="concern" className="block text-sm font-medium text-teal-700">What makes you want to seek therapy?</label>
                                    <textarea id="concern" name="concern" rows={4}
                                        value={formData.concern} onChange={handleChange} required
                                        className="mt-1 block w-full border border-teal-300 rounded-md shadow-sm p-2 bg-white text-teal-900 focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                                        maxLength={1200} />
                                </div>


                                <div>
                                    <label htmlFor="priceRange" className="block text-sm font-medium text-teal-700">
                                        Budget/Price Range (₹)
                                    </label>
                                    <select
                                        id="priceRange"
                                        name="priceRange"
                                        value={formData.priceRange}
                                        onChange={handleChange}
                                        required
                                        className="mt-1 block w-full border border-teal-300 rounded-md shadow-sm p-2 bg-white text-teal-900 focus:ring-2 focus:ring-teal-400 focus:border-transparent">
                                        <option value="">Select price range</option>
                                        <option value="Pro-bono (2 initial sessions subject to therapist availability)">Pro-bono (2 initial sessions, subject to therapist availability)</option>
                                        {priceRangeOptions.map(range => (
                                            <option key={range} value={range}>₹{range}</option>
                                        ))}
                                    </select>
                                </div>

                                {formData.priceRange === "Pro-bono (2 initial sessions subject to therapist availability)" && (
                                    <div className="mt-3 p-3 bg-teal-50 rounded-md border border-teal-200">
                                        <p className="text-sm text-teal-700 font-medium">
                                            Pro-bono therapy is available for:
                                        </p>
                                        <ul className="list-disc ml-5 text-sm text-teal-700">
                                            <li>College students</li>
                                            <li>Currently unemployed individuals</li>
                                        </ul>
                                        <label className="flex items-start mt-2">
                                            <input
                                                type="checkbox"
                                                name="probonoEligibility"
                                                checked={formData.probonoEligibility}
                                                onChange={handleChange}
                                                className="mt-1 border border-teal-300 rounded shadow-sm focus:ring-2 focus:ring-teal-400"
                                            />
                                            <span className="ml-2 text-sm text-teal-700">
                                                I confirm that I meet the eligibility criteria for pro-bono therapy
                                            </span>
                                        </label>
                                    </div>
                                )}

                                <div className="mt-1 text-sm text-teal-600 italic">
                                    Note: More experienced therapists typically charge ₹1500 and above. Pricing reflects therapist experience and specialization.
                                </div>

                                <div>
                                    <label htmlFor="referralSource" className="block text-sm font-medium text-teal-700">
                                        How did you hear about us?
                                    </label>
                                    <select
                                        id="referralSource"
                                        name="referralSource"
                                        value={formData.referralSource}
                                        onChange={handleChange}
                                        required
                                        className="mt-1 block w-full border border-teal-300 rounded-md shadow-sm p-2 bg-white text-teal-900 focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                                    >
                                        <option value="">Please select an option</option>
                                        <option value="Social Media">Social Media</option>
                                        <option value="Google Search">Google Search</option>
                                        <option value="Friend or Family">Friend or Family Referral</option>
                                        <option value="Professional Referral">Professional Referral</option>
                                        <option value="Website">Website</option>
                                        <option value="Online Advertisement">Online Advertisement</option>
                                        <option value="Event">Event or Workshop</option>
                                        <option value="Other">Other</option>
                                    </select>
                                    {formData.referralSource === "Social Media" && (
                                        <div className="mt-2">
                                            <label htmlFor="socialMediaPlatform" className="block text-sm font-medium text-teal-700">
                                                Which platform?
                                            </label>
                                            <select
                                                id="socialMediaPlatform"
                                                name="socialMediaPlatform"
                                                value={formData.socialMediaPlatform}
                                                onChange={handleChange}
                                                required
                                                className="mt-1 block w-full border border-teal-300 rounded-md shadow-sm p-2 bg-white text-teal-900 focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                                            >
                                                <option value="">Select platform</option>
                                                <option value="Instagram">Instagram</option>
                                                <option value="Facebook">Facebook</option>
                                                <option value="Twitter">Twitter</option>
                                                <option value="LinkedIn">LinkedIn</option>
                                                <option value="TikTok">TikTok</option>
                                                <option value="YouTube">YouTube</option>
                                                <option value="Other">Other</option>
                                            </select>
                                        </div>
                                    )}
                                    {formData.referralSource === "Other" && (
                                        <div className="mt-2">
                                            <label htmlFor="otherReferralSource" className="block text-sm font-medium text-teal-700">
                                                Please specify
                                            </label>
                                            <input
                                                type="text"
                                                id="otherReferralSource"
                                                name="otherReferralSource"
                                                value={formData.otherReferralSource}
                                                onChange={handleChange}
                                                required
                                                className="mt-1 block w-full border border-teal-300 rounded-md shadow-sm p-2 bg-white text-teal-900 focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                                            />
                                        </div>
                                    )}
                                </div>


                                <div>
                                    <label htmlFor="therapistPreferences" className="block text-sm font-medium text-teal-700">Therapist Preferences</label>
                                    <textarea id="therapistPreferences" name="therapistPreferences" rows={2} value={formData.therapistPreferences} onChange={handleChange}
                                        className="mt-1 block w-full border border-teal-300 rounded-md shadow-sm p-2 bg-white text-teal-900 focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                                        placeholder="Age group, gender, city, etc." />
                                </div>

                                <div>
                                    <label htmlFor="selectedTherapist" className="block text-sm font-medium text-teal-700">
                                        Select Preferred Therapist (Optional)
                                    </label>
                                    <select
                                        id="selectedTherapist"
                                        name="selectedTherapist"
                                        value={formData.selectedTherapist}
                                        onChange={handleChange}
                                        className="mt-1 block w-full border border-teal-300 rounded-md shadow-sm p-2 bg-white text-teal-900 focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                                    >
                                        <option value="">No Preference</option>
                                        {Object.values(THERAPISTS).map(therapist => (
                                            <option key={therapist.id} value={therapist.name}>
                                                {therapist.name}
                                            </option>
                                        ))}
                                    </select>
                                    {formData.selectedTherapist && (
                                        <div className="mt-2 flex items-center space-x-3">
                                            {Object.values(THERAPISTS)
                                                .filter(t => t.name === formData.selectedTherapist)
                                                .map(therapist => (
                                                    <div key={therapist.id} className="flex items-center">
                                                        <img
                                                            src={therapist.avatar}
                                                            alt={therapist.name}
                                                            className="w-12 h-12 rounded-full object-cover border-2 border-teal-300"
                                                        />
                                                        {/* <span className="ml-2 text-teal-700">{therapist.name} - {therapist.specialization.join(', ')}</span> */}
                                                        <span className="ml-2 text-teal-700">{therapist.name} </span>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    )}
                                </div>

                                <div className="flex items-start space-x-2">
                                    <input type="checkbox" id="contactConsent" name="contactConsent" checked={formData.contactConsent} onChange={handleChange} required
                                        className="mt-1 border border-teal-300 rounded shadow-sm focus:ring-2 focus:ring-teal-400 focus:border-transparent" />
                                    <label htmlFor="contactConsent" className="block text-sm text-teal-700">
                                        I agree to be contacted by the team for further clarification and with therapist profiles
                                    </label>
                                </div>

                                <div className="flex justify-end space-x-2 pt-4">
                                    <button type="button" onClick={onClose}
                                        className="px-4 py-2 border border-teal-300 rounded-md text-sm font-medium text-teal-700 hover:bg-teal-100 transition-colors duration-300">
                                        Cancel
                                    </button>
                                    <button type="submit"
                                        className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 transition-colors duration-300">

                                        {isLoading && <LoadingOverlay />}
                                        Submit

                                    </button>

                                </div>
                            </form>
                        )}
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>,
        document.body
    );
};

export default AppointmentModal;